<template>
  <div class="wrapper">
    <public-title dictionaries="字典名" type="类型" dictionariesstates="状态" @gotobtn="btn" @gotoinquire="eventinquire" :isbtn="true" btnname="新增"
      icon="el-icon-plus">
    </public-title>
    <div class="content">
  <el-table
    :data="tabledata"
    style="width: 100%;margin-bottom: 20px;"
    row-key="id"
    border
    :tree-props="{children: 'childrens', hasChildren: 'children'}"
    :default-expand-all="true"
    >
    <el-table-column
      prop="name"
      label="字典名称"
     >
    </el-table-column>
    <el-table-column
      prop="value"
      label="字典值"
      >
    </el-table-column>
    <el-table-column
      prop="code"
      label="字典编码"
      >
    </el-table-column>
    <el-table-column
      prop="type"
      label="字典类型">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间">
    </el-table-column>
    <el-table-column
      label="状态">
      <template slot-scope="scope">
        {{status(scope.row.status)}}
      </template>
    </el-table-column>
    <el-table-column label="操作" width="250" align="center">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">修改</el-button>
        <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
          @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
          title="您确定要删除这一条记录吗？"> -->
          <el-button slot="reference" size="mini" type="danger" 
          @click="handleDelete(scope.$index, scope.row)" title="您确定要删除这一条记录吗？"
          :disabled="scope.row.isMayDel==0?true:false"
          >删除</el-button>
        <!-- </el-popconfirm> -->
      </template>
    </el-table-column>
  </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>

    <el-dialog :title="issubbtn?'新增字典':'修改字典'" :before-close="handleClose" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="subform" :rules="rules" label-width="35%">
        <el-form-item label="字典名称" prop="name">
          <el-input v-model="subform.name"></el-input>
        </el-form-item>

        <el-form-item label="字典编码" prop="code">
          <el-input v-model="subform.code"></el-input>
        </el-form-item>
        
        <el-form-item label="字典类型" prop="type">
          <el-input v-model="subform.type" :disabled="istype"></el-input>
        </el-form-item>


        <el-form-item label="状态" prop="status">
          <el-select v-model="subform.status" clearable filterable style="width: 100%;" placeholder="请选择">
            <el-option
              v-for="item in dictionariesStatesArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="父节点" prop="pid">
          <el-select v-model="subform.pid" clearable filterable style="width: 100%;" @change="pid" placeholder="请选择">
            <el-option
              v-for="item in fathernodearr"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典值" prop="value" v-if="this.subform.pid!=''">
          <el-input v-model="subform.value"></el-input>
        </el-form-item>

        <el-form-item label="是否可以删除" prop="isMayDel">
          <el-radio-group v-model="subform.isMayDel">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      return {
        dictionariesStatesArr: [{
          value: '0',
          label: '无效'
        }, {
          value: '1',
          label: '有效'
        }],
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          name:'',//字典名称
          pid:'',//父节点id
          type:'',//字典类型
          value:'',//字典值
          status:'1',//状态
          code:'',
          isMayDel:''
        },
        DelVisible: false,
        dialogVisible: false,
        rules: {
          name: [
            { required: true, message: '请输入字典名称', trigger: 'blur' },
          ],
          value: [
            { required: true, message: '请输入字典值', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请输入字典类型', trigger: 'blur'  },
          ],
          status: [
            { required: true, message: '请选择状态', trigger: ['blur', 'change'] },
          ],
          isMayDel:[
            { required: true, message: '请选择是否可以删除', trigger: ['blur', 'change'] },
          ]
        },
        issubbtn:false, // edit fals - add true 
        id:'',
        fathernodearr:[],
        istype:false,//父节点开关
        isDetail:false, //是否可删除
      };
    },
    computed: {
      status(val){
        return (val)=>{
          if(val == 0){
            return '无效'
          }else{
            return '有效'
          }
        }
      }
    },
    mounted() {
      this.updata()
      this.fathernode()
    },
    methods: {
      //父节点change()
      pid(val){
        if(val){
          let obj = {};
          obj = this.fathernodearr.find((item)=>{
            return item.id === val;
          });
          this.subform.type = obj.type;
          this.istype = true
        }else{
          this.subform.type = "";
          this.istype = false  //是否类型可输入限制
        }
        
      },
      //字典删除  新增
      fathernode(){
        this.$http({
          url: this.$api.dictlists,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.fathernodearr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      //字典删除 修改
      fathernodess(id){
        this.$http({
          url: this.$api.dictlists + `?id=${id}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.fathernodearr = res.data.data
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      updata(pageIndex = 1, pageSize = 15, Vdictionaries = '', Vtype = '', Vdictionariesstates = '') {
        this.$http({
          url: this.$api.dicttree + `?pageIndex=${pageIndex}&pageSize=${pageSize}&name=${Vdictionaries}&type=${Vtype}&status=${Vdictionariesstates}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vdictionaries, this.form.Vtype, this.form.Vdictionariesstates)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vdictionaries, this.form.Vtype, this.form.Vdictionariesstates)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vdictionaries, this.form.Vtype, this.form.Vdictionariesstates)
      },
      //修改
      edit(index, item) {
        let eid = item.id;
        // 调用修改 字典
        this.fathernodess(eid)
        this.subform.name = item.columnName
        this.dialogVisible = true;
        this.issubbtn = false
        this.id = item.id

        //父节点
        /* let obj = {};
        obj = this.fathernodearr.find((items)=>{
          return item.type === items.type;
        });
        this.subform.pid = obj.id; */
        this.$http({
          url: this.$api.dictinfo + `${item.id}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data.data)
            this.subform.name = res.data.data.name
            this.subform.type = res.data.data.type
            this.subform.value = res.data.data.value
            this.subform.status = res.data.data.status.toString()
            this.subform.code = res.data.data.code
            this.subform.isMayDel = res.data.data.isMayDel
            if(res.data.data.pid == '0' || res.data.data.pid == '' ||res.data.data.pid == null ){
              this.subform.pid = ''
              this.istype = false
            }else{
               this.istype = true
              this.subform.pid = res.data.data.pid
            }
            
          }else{
            this.$toast("error", res.data.msg);
          }
        });

      },
      btn(){
        this.fathernode()


        this.subform.name = ''
        this.subform.type = ''
        this.subform.value = ''
        this.subform.pid = ''
        console.log(this.subform)
        this.dialogVisible = true
        this.subform.name = ''
        this.subform.code='' //字典编码
        this.subform.isMayDel=''//字典是否可以删除 
        this.issubbtn = true
        this.istype = false //字典类型是否可输入
      },
      //删除
      handleDelete(index, item) {
        this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.dictdel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize ,this.form.Vdictionaries, this.form.Vtype, this.form.Vdictionariesstates)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
      //新增保存
      onSubmit(formName) {
        console.log(this.subform)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,
                name:this.subform.name,//字典名称
                pid:this.subform.pid,//父节点id
                type:this.subform.type,//字典类型
                value:this.subform.value,//字典值
                status:this.subform.status,//状态
                code:this.subform.code, //字典编码
                isMayDel:this.subform.isMayDel//字典是否可以删除 
              }
              this.$http({
                url: this.$api.dictsave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize ,this.form.Vdictionaries, this.form.Vtype, this.form.Vdictionariesstates)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              let data = {
                userId,
                id:this.id,//字典id
                name:this.subform.name,
                pid:this.subform.pid,//父节点id
                type:this.subform.type,//字典类型
                value:this.subform.value,//字典值
                status:this.subform.status,//状态
                code:this.subform.code, //字典编码
                isMayDel:this.subform.isMayDel//字典是否可以删除 
              }
              this.$http({
                url: this.$api.dictupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize, this.form.Vdictionaries, this.form.Vtype, this.form.Vdictionariesstates)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.$refs['form'].resetFields();
        this.istype = false
        this.subform.type = ''
        this.subform.pid = ''

      },
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height: 100%;
  }

  /deep/.el-pagination {
    text-align: center;
    padding-bottom: 10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
    .wrapper{
    height: 100%;

  }
  /deep/.el-table{
      // overflow-x: scroll;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table th>.cell{
  color: #000;
}
/deep/.el-table__body-wrapper{
    height:63vh;
    overflow-y: auto;
}
</style>